///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.duplicate_vendor = abcsetup.duplicate_vendor || {};
abcsetup.duplicate_vendor.edit = abcsetup.duplicate_vendor.edit || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.duplicate_vendor.edit = {
    /**
     *
     */
    init: function () {
        abcsetup.setTitle('Duplicate SAP Supplier');

        // Do you plan to supply controlled substances to ABC
        $(document).on('change', '#app_models_duplicate_vendor_dea_dea_federal_controlled_substance', function() {
            if ($(this).val() == 1 || $('#app_models_duplicate_vendor_dea_dea_narcotics').val() == 1) {
                $(':input[name^="licenses"][value="primary_dea"]').prop('checked', true);
                $(':input[name^="licenses"][value="primary_dea"]').attr('readonly', false);
                $(':input[name^="licenses"][value="secondary_dea"]').prop('checked', true);
                $(':input[name^="licenses"][value="secondary_dea"]').attr('readonly', false);

                abcsetup.duplicate_vendor.common._toggleLicenses();

            } else {
                abcsetup.duplicate_vendor.common._applyLicenses(false);
            }
        });

        $(document).on('change', '#app_models_duplicate_vendor_dea_dea_narcotics', function() {
            if ($(this).val() == 1 || $('#app_models_duplicate_vendor_dea_dea_federal_controlled_substance').val() == 1) {
                $(':input[name^="licenses"][value="primary_dea"]').prop('checked', true);
                $(':input[name^="licenses"][value="primary_dea"]').attr('readonly', false);
                $(':input[name^="licenses"][value="secondary_dea"]').prop('checked', true);
                $(':input[name^="licenses"][value="secondary_dea"]').attr('readonly', false);

                abcsetup.duplicate_vendor.common._toggleLicenses();

            } else {
                abcsetup.duplicate_vendor.common._applyLicenses(false);
            }
        });
    },

    /**
     * _jquery.fieldLib
     *      Fields have been init - this is the callback
     */
    fieldsInit: function () {
        // Bind any fields events
        //abcsetup.duplicate_vendor.common.bindFields();
    },
}